<template>
  <div :class="$style.container">
    <Card
      :class="$style.card"
    >
      <slot />
    </Card>
  </div>
</template>

<script>
import { Card } from '@jumpcloud/ui-components';

export default {
  name: 'ConfirmModal',

  components: {
    Card,
  },
};
</script>

<style module scoped>
@value (max-width-medium) from '~css/breakpoints.css';

.container {
  background-image: var(--static-admin-portal-bg-img);
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  min-height: 100%;
  padding: var(--jc-spacer-medium);
}

.container::after {
  background: rgba(0, 0, 0, 0.2);
  bottom: 0;
  content: '';
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
}

.card.card {
  border-radius: 1rem;
  box-shadow: var(--jc-box-shadow-card);
  margin: auto;
  max-width: 70rem;
  overflow: hidden;
  padding: 0;
  width: 100%;
  z-index: 1;
}

@media (max-width: max-width-medium) {
  .container {
    height: 100%;
    padding: 0;
  }

  .card.card {
    border-radius: 0;
    box-shadow: none;
    height: 100%;
    margin: 0;
    max-width: auto;
    overflow-x: hidden;
    overflow-y: auto;
  }
}
</style>
